// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_Password from "../Ouroboros.Models.Brands.Password/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var InviteAcceptAction = function (x) {
    return x;
};
var FormMissing = /* #__PURE__ */ (function () {
    function FormMissing() {

    };
    FormMissing.value = new FormMissing();
    return FormMissing;
})();
var FormMismatch = /* #__PURE__ */ (function () {
    function FormMismatch() {

    };
    FormMismatch.value = new FormMismatch();
    return FormMismatch;
})();
var FormValid = /* #__PURE__ */ (function () {
    function FormValid(value0) {
        this.value0 = value0;
    };
    FormValid.create = function (value0) {
        return new FormValid(value0);
    };
    return FormValid;
})();
var tsBridgeInviteAcceptActio = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("InviteAcceptAction")("__brandInviteAcceptAction"));
        });
    }
};
var toMaybe = /* #__PURE__ */ (function () {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Data_Maybe.Nothing.value;
    })(Data_Maybe.Just.create);
})();
var runLoadingAction = function (v) {
    return v;
};
var runInviteAcceptAction = function (v) {
    return v;
};
var readState = function (v) {
    return v;
};
var readForm = function (env) {
    var passwordValue = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.password));
    var confirmValue = readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.confirmPassword));
    var $29 = passwordValue === "" || confirmValue === "";
    if ($29) {
        return FormMissing.value;
    };
    var $30 = passwordValue === confirmValue;
    if ($30) {
        return new FormValid(passwordValue);
    };
    return FormMismatch.value;
};
var optionalName = function (value) {
    var cleaned = Data_String_Common.trim(value);
    var $31 = cleaned === "";
    if ($31) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    };
    return Ouroboros_Services_Clients_Interop_Option.some(cleaned);
};
var mkInviteAcceptAction = InviteAcceptAction;
var missingTokenError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Missing invite token. Please request a new invite link."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var missingPasswordError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Please enter and confirm your password."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var mismatchedPasswordError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Passwords do not match."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var handleSuccess = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(env.onSuccess));
};
var handleInviteError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(errorValue)));
    };
};
var submitAndHandle = function (env) {
    return function (request) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleInviteError(env))(function (v) {
            return handleSuccess(env);
        })(Ouroboros_Services_Clients_Interop_TaskEither.chain(function (v) {
            return env.refreshJwtToken;
        })(env.acceptInvite(request)));
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/invite_accept_controller.md";
var buildRequest = function (env) {
    return function (tokenValue) {
        return function (passwordValue) {
            return {
                token: tokenValue,
                password: Ouroboros_Models_Brands_Password.makePassword(passwordValue),
                firstName: optionalName(readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.firstName))),
                lastName: optionalName(readState(Ouroboros_Programs_Capabilities.stateHandleRead(env.lastName)))
            };
        };
    };
};
var submitInviteAccept = function (env) {
    var v = toMaybe(env.token);
    if (v instanceof Data_Maybe.Nothing) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingTokenError)));
    };
    if (v instanceof Data_Maybe.Just) {
        var v1 = readForm(env);
        if (v1 instanceof FormMissing) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(missingPasswordError)));
        };
        if (v1 instanceof FormMismatch) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(mismatchedPasswordError)));
        };
        if (v1 instanceof FormValid) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v2) {
                return submitAndHandle(env)(buildRequest(env)(v.value0)(v1.value0));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.InviteAccept (line 71, column 7 - line 79, column 68): " + [ v1.constructor.name ]);
    };
    throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.InviteAccept (line 67, column 3 - line 79, column 68): " + [ v.constructor.name ]);
};
var mkInviteAcceptController = function (env) {
    return {
        submit: mkInviteAcceptAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(submitInviteAccept(env)))
    };
};
export {
    InviteAcceptAction,
    mkInviteAcceptController,
    runInviteAcceptAction,
    documentationPath,
    tsBridgeInviteAcceptActio
};
//# sourceMappingURL=index.js.map
